<section
	class="list-page-state"
	[class.list-page-state--error]="variant() === 'error'"
>
	@switch (variant()) {
		@case ('loading') {
			<mat-spinner diameter="40" color="primary" />
			<span>{{ message() }}</span>
		}
		@case ('empty') {
			<mat-icon class="list-page-state__icon">{{ icon() }}</mat-icon>
			<p class="list-page-state__message">{{ message() }}</p>
		}
		@case ('error') {
			<mat-icon class="list-page-state__icon">error_outline</mat-icon>
			<p class="list-page-state__message">{{ message() }}</p>
			<button mat-stroked-button color="primary" (click)="retry.emit()">
				<mat-icon>refresh</mat-icon>
				{{ retryLabel() }}
			</button>
		}
	}
</section>
